import React, {Component} from 'react';
import DateUtil from "../../utils/DateUtil";
import RemotingService from "../../services/remoting-service/RemotingService";
import InsuranceCardStatus from "./InsuranceCardStatus";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AddInsurance from "./AddInsurance";
import './InsuranceInformation.css'
import EnumCoPayUnit from "./enums/EnumCoPayUnit";
import ActionMenu from "../../components/action-menu/ActionMenu";
import ActionMenuItem from "../../components/action-menu/ActionMenuItem";
import ViewIcon from "../../components/action-menu/icons/ViewIcon";
import EditIcon from "../../components/action-menu/icons/EditIcon";
import DeleteIcon from "../../components/action-menu/icons/DeleteIcon";
import ViewInsurance from "./ViewInsurance";
import {Button} from "react-bootstrap";
import EligibilityAlertIcon from "../eligibilityalert/EligibilityAlertIcon";
import confirmDialog from "../../components/dialog/ConfirmDialog";
import GreenSwitch from "../../components/switch/GreenSwitch";
import AuthService from "../../services/auth-service/AuthService";

class InsuranceInformation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            insurances: [],
            addInsuranceModalVisible: false,
            viewInsuranceModalVisible: false,
            insurancePanelExpanded: false
        };
    }

    componentDidMount() {
        this.retrieveInsurance();
    }

    retrieveInsurance = () => {
        RemotingService.getRemoteCall(`api/insurance/${this.props.patientId}/insurance`, null, (insurances) => {
            if (insurances && insurances.length) {
                insurances.forEach(insurance => {
                    if (insurance.validityFrom) {
                        insurance.validityFrom = DateUtil.moment(insurance.validityFrom).toDate();
                    }
                    if (insurance.validityTo) {
                        insurance.validityTo = DateUtil.moment(insurance.validityTo).toDate();
                    }
                });
                insurances.sort((a, b) => {
                    if (a.isActiveMode === b.isActiveMode) {
                        return new Date(b.creationDate) - new Date(a.creationDate);
                    }
                    return a.isActiveMode ? -1 : 1;
                });
            }
            this.setState({insurances: insurances || []})
        });
    }

    onInsuranceActiveModeChanged = (insurances) => {
        if (insurances && insurances.length) {
            insurances.sort((a, b) => {
                if (a.isActiveMode === b.isActiveMode) {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                }
                return a.isActiveMode ? -1 : 1;
            });
        }
        this.setState({insurances});
    }

    render() {
        return (
            <>
                <div className="card insurance-panel" style={{minWidth:"400px", maxWidth:"1300px"}}>
                    <div className="card-header py-2 align-items-center">
                        <div className="card-header-title">
                            <strong style={{verticalAlign: "middle"}}>Insurance</strong>
                            <EligibilityAlertIcon patientId={this.props.patientId}
                                                  hasUnresolvedAlerts={this.props.hasUnresolvedAlerts}
                                                  onAlertResolved={this.props.onAlertResolved}/>
                        </div>
                        <div className="card-header-actions" style={{display: 'flex'}}>
                            <InsuranceCardStatus patientId={this.props.patientId}
                                                 editable={this.props.editable}/>
                            <div className="card-header-actions">
                                {this.props.editable &&
                                    <Button variant={"primary"} size={"sm"} className={'w-100 h-100'}
                                            onClick={() => this.showAddInsuranceModal()}
                                            style={{
                                                marginRight: '10px',
                                                padding: '0.2rem .5rem',
                                                borderRadius: '0'
                                            }}>
                                        Add
                                    </Button>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="card-body line-wrapper small-font">
                        <div className="row">
                            <div className="col-6 d-flex pr-0 w-100">
                                <div className="col-3">TPA</div>
                                <div className="col-3">Insurance</div>
                                <div className="col-3">Network</div>
                                <div className="col-3">Policy No</div>
                            </div>
                            <div className="col-6 d-flex p-0 w-100">
                                <div className="col-3">Member ID</div>
                                <div className="col-2">Validity</div>
                                <div className="col-2" style={{whiteSpace: "nowrap"}}>Co-Pay</div>
                                <div className="col-3 d-flex p-justify-center">Actions</div>
                                <div className="col-2 text-right">Active</div>
                            </div>
                        </div>
                        <hr />
                        {this.renderInsurance()}
                    </div>
                    {this.renderExpandableInsurances()}
                </div>

                {this.state.addInsuranceModalVisible &&
                <AddInsurance patientId={this.props.patientId}
                              insurance={this.state.insurance}
                              onInsuranceAdded={this.onInsuranceAdded}
                              closeAction={() =>
                                  this.setState({addInsuranceModalVisible: false})
                              }/>}

                {this.state.viewInsuranceModalVisible &&
                <ViewInsurance insuranceId={this.state.selectedInsuranceId}
                               patientId={this.props.patientId}
                               closeAction={() =>
                                   this.setState({viewInsuranceModalVisible: false})
                               }/>}
            </>
        );
    }

    renderInsurance() {
        if (!this.state.insurances || !this.state.insurances.length) {
            return (
                <div className="row">
                    <div className="col-12">
                        No record found.
                    </div>
                </div>
            );
        }

        return (
            <>
                <InsuranceRow insurance={this.state.insurances[0]}
                              patientId={this.props.patientId}
                              editable={this.props.editable}
                              retrieveInsurance={this.retrieveInsurance}
                              onInsuranceActiveModeChanged={this.onInsuranceActiveModeChanged}
                              viewAction={insuranceId => this.showViewInsuranceModal(insuranceId)}
                              editAction={insurance => this.showEditInsuranceModal(insurance)}/>
                {this.state.insurances.length > 1 &&
                    <FontAwesomeIcon
                        icon={["fa", `angle-double-${this.state.insurancePanelExpanded ? 'up' : 'down'}`]}
                        style={{position: "absolute", bottom: "4px", right: "8px", cursor: "pointer"}}
                        onClick={() => this.setState({insurancePanelExpanded: !this.state.insurancePanelExpanded})}
                    />
                }
            </>
        );
    }

    renderExpandableInsurances() {
        if (!this.state.insurances || this.state.insurances.length <= 1) {
            return null;
        }

        return (
            <div className={`card-body small-font expandable ${this.state.insurancePanelExpanded ? 'expanded' : ''}`}>
                {this.state.insurances.map((insurance, index) => {
                    if (index === 0) return null;
                    return (
                        <InsuranceRow key={insurance.id}
                                      insurance={insurance}
                                      patientId={this.props.patientId}
                                      editable={this.props.editable}
                                      retrieveInsurance={this.retrieveInsurance}
                                      onInsuranceActiveModeChanged={this.onInsuranceActiveModeChanged}
                                      viewAction={insuranceId => this.showViewInsuranceModal(insuranceId)}
                                      editAction={insurance => this.showEditInsuranceModal(insurance)}/>
                    );
                })}
            </div>
        );
    }

    showAddInsuranceModal() {
        this.setState({
            insurance: null,
            addInsuranceModalVisible: true
        });
    }

    showEditInsuranceModal(insurance) {
        this.setState({
            insurance: insurance,
            addInsuranceModalVisible: true
        });
    }

    showViewInsuranceModal(insuranceId) {
        this.setState({
            selectedInsuranceId: insuranceId,
            viewInsuranceModalVisible: true
        });
    }

    onInsuranceAdded = (insurance) => {
        this.setState({
            addInsuranceModalVisible: false
        });
        this.retrieveInsurance();
    }
}

class InsuranceRow extends Component {

    state = {
        isActivateButtonEnabled: AuthService.isManagerOrSuperUser()
    };

    handleInsuranceActiveModeChange = (insurance) => {
        const url = insurance.isActiveMode
            ? `api/insurance/deactivate?insuranceId=${insurance.id}`
            : `api/insurance/activate?insuranceId=${insurance.id}`;
        RemotingService.postRemoteCall(url, null, (insurances) => {
            this.props.onInsuranceActiveModeChanged(insurances);
        });
    };

    render() {
        const insurance = this.props.insurance;
        const validityFrom = insurance.validityFrom ? DateUtil.formatDateMMM(insurance.validityFrom) : '';
        const validityTo = insurance.validityTo ? DateUtil.formatDateMMM(insurance.validityTo) : '';

        return (
            <div className="row">
                <div className="col-6 d-flex pr-0 w-100">
                    <div className="col-3" style={{whiteSpace: "pre-wrap"}}>{this.tpaTemplate(insurance)}</div>
                    <div className="col-3" style={{whiteSpace: "pre-wrap"}}>{insurance.company ? insurance.company.name : insurance.customCompany}</div>
                    <div className="col-3" style={{whiteSpace: "pre-wrap"}}>{insurance.network ? insurance.network.name : insurance.customNetwork}</div>
                    <div className="col-3" style={{whiteSpace: "pre-wrap"}}>{insurance.policyNumber}</div>
                </div>
                <div className="col-6 d-flex p-0 w-100">
                    <div className="col-3 text-wrap">{insurance.memberId}</div>
                    <div className="col-2" style={{whiteSpace: "pre-wrap"}}>{validityFrom} to {validityTo}</div>
                    <div className="col-2" style={{whiteSpace: "pre-wrap"}}>{insurance.coPay} {EnumCoPayUnit[insurance.coPayUnit]}
                        {insurance.coPayMax ? ` (Max: ${insurance.coPayMax})` : ''}
                        {insurance.coPayRules && insurance.coPayRules.length > 0 ?
                            <span className="badge badge-info" style={{marginLeft: "4px"}}
                                  title="CPT-specific co-pay rules">+{insurance.coPayRules.length} CPT rules</span> : null}</div>
                    <div className="col-3 d-flex p-justify-center">{this.actionsTemplate(insurance)}</div>
                    <div className="col-2 text-right">
                        {this.state.isActivateButtonEnabled ? (
                            <GreenSwitch checked={insurance.isActiveMode}
                                         onChange={() => this.handleInsuranceActiveModeChange(insurance)}/>
                        ) : insurance.isActiveMode ? (
                            <FontAwesomeIcon icon={["fas", "check"]} color={"#7aae00"} style={{marginRight: "5px"}}/>
                        ) : (
                            <FontAwesomeIcon icon={["fas", "times"]} color={"red"} style={{marginRight: "8px"}}/>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    tpaTemplate(insurance) {
        if (insurance.tpa) {
            return insurance.tpa.name;
        } else if (insurance.insurer) {
            return insurance.insurer.name;
        } else if (insurance.customTpa) {
            return insurance.customTpa;
        } else {
            return "";
        }
    }

    actionsTemplate = (insurance) => {
        return <ActionMenu id="insuranceActionMenu">
                    <ActionMenuItem text="View"
                                    onClick={() => this.props.viewAction(insurance.id)}
                                    icon={<ViewIcon/>}/>
                    {this.props.editable &&
                        <ActionMenuItem text="Edit"
                                        onClick={() => this.props.editAction(insurance)}
                                        icon={<EditIcon/>}/>
                    }
                    <ActionMenuItem text="Sync"
                                    disabled={insurance.type === "MANUAL"}
                                    onClick={() => this.sync(insurance.id)}
                                    icon={<FontAwesomeIcon icon={["fas", "sync-alt"]}/>} />
                    {this.props.editable &&
                        <ActionMenuItem text="Delete"
                                        onClick={() => this.delete(insurance.id)}
                                        icon={<DeleteIcon/>} />
                    }
                </ActionMenu>
    }

    sync = (insuranceId) => {
        RemotingService.postRemoteCall(`api/insurance/${insuranceId}/sync`, null, () => {
            this.props.retrieveInsurance();
        });
    }

    delete = (insuranceId) => {
        confirmDialog("Delete Insurance",
            "Are you sure you want to delete this insurance information? This action cannot be undone.",
            () => {
                RemotingService.deleteRemoteCall(`api/insurance/${insuranceId}`, null, () => {
                    this.props.retrieveInsurance();
                });
            });
    }

}

export default InsuranceInformation;
